import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import { FieldTypes, filterFieldsForForm } from 'drapcode-constant';
import CreateFormForItem from '../../item/CreateFormForItem';
import { drapcodeIcon, iconForField } from '../../../../common/custom/icon-library';
import { notAllowedWord, reservedValues } from '../../../../common/formElements/reservedKeywords';
import FormFieldWithLabel from '../../../common/FormFieldWithLabel';
const { boolean } = FieldTypes;
export default class ConstructorForm extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    commonActions: PropTypes.object.isRequired,
    projectId: PropTypes.string.isRequired,
    collection: PropTypes.object.isRequired,
    collections: PropTypes.object.isRequired,
  };

  componentDidMount = () => {
    const {
      actions: { loadProjectCollections },
      projectId,
      version,
    } = this.props;
    loadProjectCollections({ projectId, version });
  };

  createSchemaForPluginConfiguration = () => {
    const fields = filterFieldsForForm(this.props.collection.fields);
    const { item } = this.props;
    let schema = { customConstructorName: '' };
    Object.keys(fields).map((field) => {
      const fieldDetail = fields[field];
      if (
        fieldDetail.type === FieldTypes.reference.id &&
        fieldDetail.refCollection.displayType === 'innerFormNd'
      ) {
        const { collections } = this.props.collections;
        const { collectionName } = fieldDetail.refCollection;
        const refCollection =
          collections.length > 0
            ? collections.find((collection) => collection.collectionName === collectionName)
            : null;
        let referenceSchema = {};
        refCollection.fields.forEach((field) => {
          referenceSchema[field.fieldName] = '';
        });
        schema[fieldDetail.fieldName] = referenceSchema;
      } else {
        schema[fieldDetail.fieldName] = item ? item[fieldDetail.fieldName] : '';
      }
    });
    return schema;
  };

  handleSubmit = (values, setErrors, setSubmitting, resetForm) => {
    setSubmitting(false);
    const { projectId, version, actions, collection, commonActions } = this.props;
    let constructorName = values.customConstructorName;
    delete values['customConstructorName'];
    let constructorObj = { customConstructorName: constructorName, constructorData: values };
    actions
      .createCollectionConstructor({
        projectId,
        version,
        collectionUuid: collection.uuid,
        data: constructorObj,
      })
      .then((_response) => {
        resetForm();
      });
    commonActions.trackCollectionChange({ uuid: collection.uuid });
  };

  validateConstructorName = (value) => {
    if (!value || value.length === 0) {
      return 'Name is Required.';
    }
    if (value && value.length > 100) {
      return `Name can\'t be more than 100 characters.`;
    }
    if (!/^[0-9A-Za-z\s]+$/.test(value)) {
      return 'Name should not contain special characters.';
    }
    const lowercaseValue = value ? value.toLowerCase() : '';
    if (reservedValues.includes(lowercaseValue)) {
      return `This is reserved word please use another`;
    }
    if (notAllowedWord.includes(lowercaseValue)) {
      return `This type of word not allowed.`;
    }
  };
  //TODO: Refactor to common component
  createConstructorForm = () => {
    const { projectId, collection, collections, version, item, plugins, s3Url, isReadOnly } =
      this.props;
    const fields = filterFieldsForForm(collection.fields);
    if (fields) {
      return (
        <Formik
          enableReinitialize={true}
          initialValues={this.createSchemaForPluginConfiguration()}
          onSubmit={(values, { setSubmitting, resetForm, setErrors }) => {
            isReadOnly ? null : this.handleSubmit(values, setErrors, setSubmitting, resetForm);
          }}
        >
          {({ isSubmitting, values, setFieldValue, setSubmitting, setErrors, errors }) => (
            <Form className="form-horizontal collection-constructor-form">
              <div className="row mx-auto">
                <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                  <div className="form-group">
                    <FormFieldWithLabel
                      cta={false}
                      label={'Constructor Name'}
                      icon={'text'}
                      infoIcon={true}
                      infoDescription={''}
                    >
                      <Field
                        type="text"
                        name="customConstructorName"
                        className="form-control form-control-sm"
                        placeholder="Name of Constructor"
                        validate={this.validateConstructorName}
                      />
                      <ErrorMessage name="customConstructorName">
                        {(msg) => <p className="text-error">{msg}</p>}
                      </ErrorMessage>
                    </FormFieldWithLabel>
                  </div>
                </div>
                {fields
                  ? fields.map((field) => (
                      <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                        <div className="form-group">
                          <FormFieldWithLabel
                            key={field._id}
                            cta={false}
                            label={field.fieldTitle['en']}
                            icon={field.type === boolean.id ? `${field.type}-toggle` : field.type}
                            infoIcon={true}
                            infoDescription={''}
                            isRequired={''}
                          >
                            <CreateFormForItem
                              field={field}
                              values={values}
                              itemId={this.props.item ? this.props.item.uuid : null}
                              collectionId={collection.collectionName}
                              projectId={projectId}
                              version={version}
                              setFieldValue={setFieldValue}
                              setErrors={setErrors}
                              setSubmitting={setSubmitting}
                              collections={collections}
                              isConstructorForm={true}
                              plugins={plugins}
                              s3Url={s3Url}
                            />
                          </FormFieldWithLabel>
                        </div>
                      </div>
                    ))
                  : ''}
              </div>
              <div className="row">
                <div className="col-md-12 text-right">
                  <button type="reset" className="btn btn-default btn-md">
                    <i className={`wb ${drapcodeIcon('reset')}`}></i>&nbsp;Reset
                  </button>
                  &nbsp;&nbsp;
                  <button
                    type="submit"
                    className="btn btn-theme-submit btn-md"
                    disabled={
                      isSubmitting || collections.showConstructorCreateLoader || isReadOnly
                        ? 'disabled'
                        : ''
                    }
                  >
                    <i className={`wb ${drapcodeIcon('save')}`}></i>&nbsp;Save
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      );
    } else {
      return '';
    }
  };
  render() {
    return (
      <div className="row pt-1">
        <div className="col-12">{this.createConstructorForm()}</div>
      </div>
    );
  }
}
